// extracted by mini-css-extract-plugin
module.exports = {"billboard":"PlayButton_billboard__3jw84","playIcon":"PlayButton_playIcon__3KPmZ","spinner":"PlayButton_spinner__1GXOs"};